<template>
  <div class="modal__field_transferrer">
    <div>
      <label>
        От кого передано<span class="field__label_required">*</span>
      </label>
    </div>
    <Select
      class="form-group"
      :options="types"
      :default-key="selectedType"
      @input="setType"
    />
    <div
      v-for="modal, modalName in openedModals"
      :key="modal.title"
      class="field__input"
    >
      <ForeignKeyInput
        v-if="selectedType === modalName"
        :record-link="getRecordLink(modal)"
        :value="value"
        @on-trash-click="$emit('on-delete')"
        @on-plus-click="modal.isVisible = true"
      />
      <EntityReferencesModal
        v-if="modal.isVisible"
        :title="modal.title"
        :link-slug="modal.slug"
        :table-fields="modalTableFields"
        @choose="setTransferrer"
        @close="modal.isVisible = false"
        allow-only-one-choise
        not-only-ids
      />
    </div>
  </div>
</template>

<script>
import Select from '@/_shared/components/ui/Select';
import ForeignKeyInput from '@/_shared/components/ui/ForeignKeyInput';
import EntityReferencesModal from '@/_shared/components/modals/EntityReferencesModal';
import { modals } from "@/_shared/constants";
export default {
  emits: ["on-set", "on-delete"],
  components: {
    Select,
    ForeignKeyInput,
    EntityReferencesModal,
  },
  props: {
    value: {
      type: Object | null,
      default: null,
    },
    initType: {
      type: String | null,
      required: true,
    },
  },
  data() {
    return {
      openedModals: {
        transferrer_user_id: {
          title: 'Выбор сотрудника',
          slug: 'users',
          isVisible: false,
        },
        transferrer_provider_id: {
          title: 'Выбор компании-поставщика',
          slug: 'providers',
          isVisible: false,
        },
      },
      types: {
        transferrer_provider_id: "Поставщик",
        transferrer_user_id: "Сотрудник",
      },
      selectedType: this.initType || 'transferrer_provider_id',
    };
  },
  computed: {
    modalTableFields() {
      if (this.selectedType === 'transferrer_user_id') {
        return modals.users.fields;
      }
    },
  },
  methods: {
    getRecordLink(modal) {
      if (this.value) {
        const link = `/${modal.slug}/${this.value.id}`;
        return link;
      }
    },
    setTransferrer(value) {
      value = {
        ...value,
        foreign_key: this.selectedType,
      };
      this.$emit('on-set', value);
    },
    setType(value) {
      if (value !== this.selectedType) {
        this.$emit('on-delete');
      }
      this.selectedType = value;
    },
  },
};
</script>

<style scoped>
.modal__field_transferrer {
  display: flex;
  flex-direction: column;
}
.modal__field_transferrer > .field__input > * {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/stock/features/stock-movement/TransferrerField.vue